import Avatar1 from "../../images/SCREENSHOT/Avatar1.png";
import Avatar2 from "../../images/SCREENSHOT/Avatar2.jpeg";
import Avatar3 from "../../images/SCREENSHOT/Avatar3.avif";
import Avatar4 from "../../images/SCREENSHOT/Avatar4.avif";
import Avatar5 from "../../images/SCREENSHOT/Avatar5.png";
import Avatar6 from "../../images/SCREENSHOT/Avatar6.png";
import Avatar7 from "../../images/SCREENSHOT/Avatar7.svg";
import Avatar8 from "../../images/SCREENSHOT/Avatar8.jpg";
import Avatar9 from "../../images/SCREENSHOT/Avatar9.jpeg";
import Avatar10 from "../../images/SCREENSHOT/Avatar10.jpg";

const TestimonialsDataLink = [
  {
    id: 1,
    Avatar: Avatar1,
    name: "Sarah Johnson (WordPress Blog Site)",
    quote:
      "Working with you was a breeze! You delivered a beautiful, responsive blog site on WordPress that exceeded my expectations. I especially appreciated your attention to SEO and user experience.",
    profession: "https://www.linkedin.com/in/sarah-johnson",
  },
  {
    id: 2,
    Avatar: Avatar2,
    name: "David Thompson (WordPress Business Site)",
    quote:
      "Incredible experience! You built a sleek, fast-loading WordPress website for my consulting firm and guided me on content placement. My clients love the new look!",
    profession: "https://www.linkedin.com/in/david-thompson",
  },
  {
    id: 3,
    Avatar: Avatar3,
    name: "Priya Mehta (Backend API Development)",
    quote:
      "You handled the backend for our mobile app flawlessly. The API design was clean, scalable, and well-documented. Your problem-solving skills are top-notch!",
    profession: "https://www.linkedin.com/in/priyamehta",
  },
  {
    id: 4,
    Avatar: Avatar4,
    name: "Mark Evans (E-commerce WordPress Store)",
    quote:
      "Thanks for building my WooCommerce site from scratch. It’s fast, intuitive, and handles orders smoothly. You've helped my online sales grow significantly!",
    profession: "https://www.linkedin.com/in/markevans",
  },
  {
    id: 5,
    Avatar: Avatar5,
    name: "Fatima Al-Hassan (Backend User Auth System)",
    quote:
      "Your backend work was exactly what we needed — secure user authentication, JWT token handling, and efficient database integration. Highly recommend your backend expertise.",
    profession: "https://www.linkedin.com/in/fatimaalhassan",
  },
  {
    id: 6,
    Avatar: Avatar6,
    name: "Lucas Bennett (React Frontend Dashboard)",
    quote:
      "You created a fantastic admin dashboard in React that is both functional and beautiful. The UX is clean, and data handling works perfectly. Thanks for your hard work!",
    profession: "https://www.linkedin.com/in/lucas-bennett",
  },
  {
    id: 7,
    Avatar: Avatar7,
    name: "Isabella Nguyen (Backend Booking System)",
    quote:
      "The custom backend booking system you built was a game changer. It’s reliable, secure, and handles thousands of bookings seamlessly. Your work made our platform robust.",
    profession: "https://www.linkedin.com/in/isabellanguyen",
  },
  {
    id: 8,
    Avatar: Avatar8,
    name: "Nathan O’Connor (Frontend Landing Page)",
    quote:
      "Stunning work on the React landing page. It’s modern, mobile-friendly, and loads lightning-fast. You nailed the branding and layout perfectly!",
    profession: "https://www.linkedin.com/in/nathanoconnor",
  },
  {
    id: 9,
    Avatar: Avatar9,
    name: "Chinwe Okeke (Backend Microservices Project)",
    quote:
      "I’m truly impressed by your backend architecture for our microservices. Your code was clean and modular, making maintenance a breeze. Outstanding collaboration!",
    profession: "https://www.linkedin.com/in/chinweokeke",
  },
  {
    id: 10,
    Avatar: Avatar10,
    name: "James Kim (Frontend E-Learning Platform)",
    quote:
      "Your React frontend for our e-learning platform was spot-on. Intuitive layout, smooth navigation, and pixel-perfect design. Our users love it!",
    profession: "https://www.linkedin.com/in/jameskim",
  },
];

export default TestimonialsDataLink;
